import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./Components/Header";
import Projects from "./Components/Projects";
import AboutMe from "./Components/AboutMe";
import Contact from "./Components/Contact";

function App() {
  const [home, setHome] = useState(true);
  const [aboutMe, setAboutMe] = useState(false);
  const [contact, setContact] = useState(false);

  return (
    <div className="App">
      <Router>
        <Header
          home={home}
          setHome={setHome}
          aboutMe={aboutMe}
          setAboutMe={setAboutMe}
          contact={contact}
          setContact={setContact}
        />
        <Routes>
          <Route
            path={"/"}
            element={
              <Projects
                setHome={setHome}
                setAboutMe={setAboutMe}
                setContact={setContact}
              />
            }
          />
          <Route
            path={"/portfolio-last"}
            element={
              <Projects
                setHome={setHome}
                setAboutMe={setAboutMe}
                setContact={setContact}
              />
            }
          />
          <Route
            path={"/portfolio-last/aboutme"}
            element={
              <AboutMe
                setHome={setHome}
                setAboutMe={setAboutMe}
                setContact={setContact}
              />
            }
          />
          <Route
            path={"/portfolio-last/contact"}
            element={
              <Contact
                setHome={setHome}
                setAboutMe={setAboutMe}
                setContact={setContact}
              />
            }
          />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
